import React, {useState} from 'react';
import IconButton from "@mui/material/IconButton";
import {pathParams} from "path-params";
import {Routes} from "../../constants/Routes";
import {useHistory, useParams} from "react-router";
import {useIntegrationsContext} from "../../api/integrations/IntegrationsContext";
import DeleteIcon from '@mui/icons-material/Delete';
import {toast} from "react-toastify";
import {showError} from "../../utils/NotificationUtils";
import {DialogWindow} from "../ui/DialogWindow";
import {AppButton} from "../ui/AppButton";

interface Props {
    readonly item: any
    readonly isTrigger?: boolean
}

export function IntegrationEventListItem({isTrigger, item}: Props) {
    const history = useHistory();
    const params: any = useParams();
    const [deleted, setDeleted] = useState<boolean>(false);
    const {IntegrationsApi} = useIntegrationsContext();
    const [showDialog, setShowDialog] = useState(false);

    const onDelete = () => {
        IntegrationsApi.IntegrationEventDelete(`${isTrigger ? "trigger" : "action"}/delete/${item.id}`).then(() => {
            toast.success("Deleted");
            setDeleted(true);
            setShowDialog(false)
        }).catch(err => {
            showError(err)
        })
    };
    return (
        <>
           {!deleted && (
            <tr>
                <td>{item.name}</td>
                <td>{item.code}</td>
                <td>{item.description}</td>
                <td style={{width: "200px"}}>
                    <IconButton onClick={() => setShowDialog(true)}>
                        <DeleteIcon/>
                    </IconButton>
                    <AppButton sx={{ml: 2}} onClick={() => {
                        history.push(pathParams(
                            isTrigger ? Routes.IntegrationEditorTriggerEditor : Routes.IntegrationEditorActionsEditor,
                            {
                                triggerId: item.id,
                                actionId: item.id,
                                id: params.id
                            }
                        ))
                    }}>Details</AppButton>
                </td>
            </tr>
            )}
            <DialogWindow
                show={showDialog}
                onClose={() => setShowDialog(false)}
                onCancel={() => console.log("hello")}
                onAgree={onDelete}>
                Are you sure?
            </DialogWindow>
        </>
    );
}

